// extracted by mini-css-extract-plugin
export default {"container":"OM-z","darkBackground":"PM-z","whiteBackground":"QM-z","headerButton":"RM-z","calloutHeading":"SM-z","calloutSubHeading":"TM-z"};